import React, { useCallback, useMemo, useState } from 'react'

import { COLORS, THEME } from '../../styles'
import { useTranslation } from '../../contexts/I18nContext'
import { formatRecipeSlug } from '../../helpers'

import Styled from './RecipeCookingSupporting.styled'

/**
 * Component
 * @param {string} className
 * @param {JSX.Element} children
 * @param {number} coversCount
 * @param {string} id
 * @param {boolean} isLoading
 * @param {string} slug
 * @param {string} title
 */
const RecipeCookingSupporting = ({
  className,
  coversCount,
  favorRecipe,
  favorites,
  id,
  isLoading,
  ordered,
  slug,
  source,
  title,
}) => {
  const { t } = useTranslation()
  const isFavored = useMemo(
    () => favorites.some((favorite) => favorite === id),
    [favorites, id],
  )
  const [favored, setFavored] = useState(isFavored)
  const handleFavor = useCallback(() => {
    setFavored(!favored)
    favorRecipe({ id, title, source })
  }, [id, title, favorRecipe, favored, source])

  const page = useMemo(() => {
    const path = source === 'user-generated' ? 'user-recipes' : 'recipes'
    return id
      ? `/${path}/${formatRecipeSlug({ id, slug, coversCount })}`
      : undefined
  }, [coversCount, id, slug, source])

  return (
    <Styled className={className}>
      <Styled.recipeLink isLoading={isLoading} to={page}>
        {t(ordered ? 'COOK' : 'RECIPE.SEE')}
      </Styled.recipeLink>
      <Styled.favorButton onClick={handleFavor} disabled={isLoading}>
        {isLoading ? (
          <Styled.iconLoading viewBox="0 0 34 34">
            <circle
              cx={14}
              cy={14}
              r={14}
              fill={THEME.COLORS.background.tertiary}
            />
          </Styled.iconLoading>
        ) : (
          <Styled.favorIcon
            width={24}
            height={24}
            name={favored ? 'heart-fill-24' : 'heart-stroke-24'}
            fill={favored ? COLORS.primary : THEME.COLORS.foreground.secondary}
          />
        )}
      </Styled.favorButton>
    </Styled>
  )
}

RecipeCookingSupporting.defaultProps = {
  favorites: [],
  isLoading: false,
  ordered: false,
}

export default RecipeCookingSupporting
